import { AppTheme } from "../../types/Theme";

export const LightTheme = {
	primary: "#2F4153",
	background: "#EAEAEA",
	surface1: "#FFFFFF",
	surface2: "#D3D3D3",
	surface3: "#EDEDED",
	secondaryText: "#AFAFAF",
	whiteText: "#FFFFFF",
	error: "#BD1823",
} as AppTheme;